module.exports = __webpack_public_path__ + "static/img/manual_zh_23.bf83dae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_23.png
// module id = 8ruU
// module chunks = 4